<template>
  <div>
    <FormSearchableSelect
      v-show="!loadingError"
      :value="value"
      :options="orderLookup"
      :filterable="false"
      @input="updateValue($event)"
      @search="searchValue"
      :placeholder="placeholder"
      :field="field"
      :note="note"
      :loading="loading"
    />
    <span class="text-danger" v-if="loadingError">{{loadingError}}</span>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'OrderSearchableSelect',
  model: {
    event: 'input'
  },
  props: {
    value: [Number, String],
    placeholder: {
      type: String,
      default: 'Order'
    },
    contactId: Number,
    field: String,
    note: String,
    nullSelectionEnabled: {
      type: Boolean,
      default: false
    },
    nullSelectionName: {
      type: String,
      default: 'No Order'
    }
  },
  data() {
    return {
      loading: false,
      loadingError: '',
      orderLookup: [],
      searchableText: '',
      searchableLoadingFn: null
    }
  },
  watch: {
    contactId: function() {
      // Clear orders if contact changes
      this.orderLookup = []
    }
  },
  computed: {
  },
  created() {
    this.debouncedSearchOrders = _.debounce(this._searchOrders, 100)
  },
  mounted() {
   
  },
  methods: {
    updateValue(id) {
      console.log(`updated: ${id}`)
      this.$emit('input', id)
    },
    searchValue(search, loading) {
      this.searchableLoadingFn = loading
      this.searchableText = search

      this.debouncedSearchOrders()
    },
    _searchOrders() {
      var params = {
        filter: {
          contactId: this.contactId,
        },
        search: { value: this.searchableText },
        order: [{ column: 0, dir: 'DESC' }],
        columns: [{ data: 'dateOrderCreated' }],
      }

      if(this.searchableText == '') {
        return
      }

      if(this.searchableLoadingFn)
        this.searchableLoadingFn(true)

      this.$apiService.ordersService.getOrderFilteredList(params)
      .then(response => {
        this.orderLookup = response.data.map(order => {
          return {
            value: order.id,
            name: `${order.sequenceNumber}${order.customerRef ? ' - ' : ''}${order.customerRef}`
          }
        })
      })
      .catch(err => {
        this.loadingError = this.processFormResponse(err).errorMessage

      })
      .finally(() => {
        if(this.searchableLoadingFn)
          this.searchableLoadingFn(false)
      })

    }
  }
}
</script>